import { Shape } from "../../helpers/Shape";
import { EntityService } from "../EntityService";
import { Pit } from "./Pit";
import { TYPES } from "../../EntityManager";
import { graphic } from "../../Graphic";

export class PitService extends EntityService {

    static upsertFromProps(pitsProps) {
        super.upsertFromProps(TYPES.PIT, pitsProps);
    }

    static createGraphicItem(dimensions, color = null) {
        return Shape.createRectangle(
            dimensions.xo,
            dimensions.yo,
            dimensions.xd,
            dimensions.yd,
            [1, 0xFFFFFF, 0.1, 1],
            color === null ? 0xBD3D3A : color,
            1
        );
    }

    static createFromProps(props) {
        const { id, container } = super.createFromProps(props);
        const { category } = props;

        const dimensions = {
            xo: 0,
            yo: 0,
            xd: props.width,
            yd: props.height
        };

        const color = !category ? null : `0x${category.color.replace('#', '')}`;
        const graphicItems = [PitService.createGraphicItem(dimensions, color)];
        return new Pit({ id, container, graphicItems, category, width: props.width, height: props.height });
    }

    static changeCategory({ pitsId, category }) {
        pitsId.forEach(pitId => graphic.entityManager.get(TYPES.PIT, pitId).setCategory(category));
    }
}